// extracted by mini-css-extract-plugin
export default {"danger":"#ac0000","warning":"#e5a212","success":"#359685","suggestion":"#bccdcb","alert":"#364548","info":"#1f2628"};